import React from 'react';
import { toast } from 'react-toastify';

// styles
import 'react-toastify/dist/ReactToastify.css';
import useStyles from '../components/Notification/styles.send';

import Notification from '../components/Notification';

const positions = [
  toast.POSITION.TOP_LEFT,
  toast.POSITION.TOP_CENTER,
  toast.POSITION.TOP_RIGHT,
  toast.POSITION.BOTTOM_LEFT,
  toast.POSITION.BOTTOM_CENTER,
  toast.POSITION.BOTTOM_RIGHT,
];

export default function handleNotificationCall(componentProps) {
  return toast(
    <Notification
      {...componentProps}
    />,
    componentProps.options,
  );
}
